require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.symbol.observable.js
// module id = 314
// module chunks = 27